import { render, staticRenderFns } from "./FormMobileTercatatReadonly.vue?vue&type=template&id=20765849&"
import script from "./FormMobileTercatatReadonly.vue?vue&type=script&lang=js&"
export * from "./FormMobileTercatatReadonly.vue?vue&type=script&lang=js&"
import style0 from "./FormMobileTercatatReadonly.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports